import axios from "axios";

const serverUrl = process.env.REACT_APP_API;

export const logIn = dados => {
  localStorage.setItem("un", dados.user);
  localStorage.setItem("saat", dados.tokenId);
  localStorage.setItem("srat", dados.refreshToken);

  return {
    type: "LOGIN",
    dados,
  };
};

export const logOut = () => {
  localStorage.clear();
  return { type: "LOGOUT" };
};

export const setDados = dados => {
  return {
    type: "SETDADOS",
    dados,
  };
};

export const setDadosPesq = (name, dados) => {
  return {
    type: "SETDADOSPESQ",
    name,
    dados,
  };
};

export const fetchNoAuth = () => {
  return dispatch => {
    return axios.create({
      baseURL: serverUrl,
    });
  };
};

export const fetch = () => {

  return (dispatch) => {

    const tokenId = localStorage.getItem('saat');

    const http = axios.create({
      baseURL: serverUrl
    });

    http.defaults.headers.common['Authorization'] = 'Bearer ' + tokenId;

    http.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      const originalRequest = error.config

      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true

        const refreshToken = localStorage.getItem('srat');

        const dados = { username: 'username', tokenId, refreshToken };

        return http.post(http.defaults.baseURL + '/TokenRefresh', dados)
          .then((responseData) => {
            localStorage.setItem('saat', responseData.data.tokenId);
            //localStorage.setItem('srat', responseData.data.refreshToken);

            dispatch({ type: 'LOGIN', dados: { tokenId: responseData.data.tokenId, refreshToken: responseData.data.refreshToken } })

            http.defaults.headers.common['Authorization'] = responseData.data.tokenId
            originalRequest.headers['Authorization'] = responseData.data.tokenId
            //retry failed request
            return http(originalRequest)
          }).catch(function (error) {
            dispatch({ type: 'LOGOUT' })
          })
      }

      return Promise.reject(error)
    });

    return http;
  }
};
